import { SET_FILTER_OPTIONS, CLEAR_FILTER_OPTIONS } from "constants/types";

export const setFilterOptions = (key, data) => ({
  type: SET_FILTER_OPTIONS,
  payload: { key, value: data },
});

export const clearFilterOptions = () => ({
  type: CLEAR_FILTER_OPTIONS,
});
